module.exports = __webpack_public_path__ + "static/media/lulc_modis.775444ac.tif";